<template>
  <div class="nav-bar" :style="{ background: bgColor }">
    <div class="nav-bar-left" :style="{ visibility: hiddenBack ? 'hidden' : 'visible' }">
      <slot name="left"
        ><img class="goback" src="@images/common/new_back.png" alt="" @click="goBack"
      /></slot>
    </div>
    <div class="nav-bar-title">
      <slot name="title"
        ><span class="van-ellipsis nav-bar-title-move">{{
          title ? title : currentTitle
        }}</span></slot
      >
    </div>

    <!-- <slot name="title"><span class="van-ellipsis"> {{title ? title : currentTitle}}</span></slot> -->
    <div class="nav-bar-right">
      <slot name="right"><img class="right-mask" src="@images/common/new_back.png" alt="" ></img></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from '@utils/vuex'

export default {
  props: {
    title: {
      type: String,
      require: false,
      default: ''
    },
    hiddenBack: {
      type: Boolean,
      require: false,
      default: false
    },
    bgColor: {
      type: String,
      require: false,
      default: '#f4f4f4'
    }
  },
  computed: mapGetters(['currentTitle', 'canGoback', 'isInApp']),
  created () {
    console.log('navbar created', this.canGoback)
  },
  methods: {
    goBack () {
      if (this.$listeners.leftClick) {
        this.$emit('leftClick')
      } else {
        // if (this.isInApp) {
        //   uni.$nativeBridge.sendMessage(
        //     new NativeMessageNotice({
        //       type: 'goBack',
        //       params: {}
        //     })
        //   )
        // } else {
        //   this.$router.go('-1')
        this.$router.back()
        // }
        // if (!this.canGoback) {
        //   this.$router.push('/')


        //   this.$router.back()
        // }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@styles/variables.scss';
.nav-bar {
  width: 100%;
  height: 1.92rem;
  display: flex;
  align-items: center;

  .goback {
    cursor: pointer;
  }

  > span {
    flex: 1;
    font-size: $fsxl;
    color: #111;
    text-align: center;
  }

  .nav-bar-left {
    padding-right: 0.64rem;
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    // width: 2.96rem;
    margin-left: 0.64rem;

    > img {
      width: 0.85rem;
      height: 0.85rem;
    }
  }

  .nav-bar-title {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .nav-bar-right {
    padding-left: 0.64rem;
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    // width: 2.96rem;
    margin-right: 0.64rem;

    .right-mask {
      display: block;
      width: 0.85rem;
      height: 0;
      overflow: hidden;
      visibility: hidden;
    }
  }
}
</style>
